<template lang="html">
  <footer class="input-footer">
    <transition name="fade">
      <div v-if="!error && helperText" class="helper-text">{{helperText}}</div>
      <div v-if="error" class="helper-text validation-error">{{error}}</div>

      <div v-if="!error && !helperText" class="helper-text"></div>
    </transition>

    <span v-if="limit" :class="{'counter': 1, 'is-full': full}">{{count}}/{{limit}}</span>
  </footer>
</template>

<script>
  export default {
    name: 'input_footer',

    props: ['error', 'helperText', 'count', 'limit'],

    computed: {
      full() {
        if(this.limit) {
          return this.count >= this.limit
        }
      }
    }
  }
</script>

<style lang="sass">
  @import '../../../styles/base/variables'

  .input-footer
    display: flex
    flex-direction: rows
    font-size: 0.75em
    padding-top: 7px
    justify-content: flex-end

    // inactive
    color: $color-text

    .counter
      transition: color $transition-duration $transition-easing
      padding: 0 10px 10px

      &.is-full
        color: $color-primary

    .helper-text
      flex: 1
      min-height: 12px
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/inputs/InputFooter.vue